module.exports = __webpack_public_path__ + "img/check.c5af4a38.png";